import {Injectable} from '@angular/core';
import {Actions, Effect, ofType} from '@ngrx/effects';
import {Action, select, Store} from '@ngrx/store';
import {Observable} from 'rxjs/Observable';
import {filter, map, withLatestFrom} from 'rxjs/operators';
import {
    AKTUELLEN_PRUEFLAUF_ENTFERNEN,
    AKTUELLEN_PRUEFLAUF_SETZEN, AktuellenPrueflaufEntfernenAction,
    AktuellenPrueflaufSetzenAction, AUFGABE_BEMERKUNG_SPEICHERN, AufgabeBemerkungSpeichernAction,
    PAGE_STATE_RESET,
    PageStateResetAction, PRUEFAUFGABE_KORRIGIEREN, PruefaufgabeKorrigierenAction, PRUEFLAUF_DETAIL_NEU_LADEN, PrueflaufDetailNeuLaden, VERANSTALTUNG_UEBERSICHT_NEU_LADEN
} from './qs-checks-controlling-veranstaltung.actions.ui';
import {UuidService} from '@orga-app/providers/uuid.service';
import {getAktuelleVeranstaltung, getPrueferRollenIds, getPruefplanId} from '../qschecks-controlling-home/qs-checks-controlling-home.selectors';
import {GetVeranstaltungUebersichtAction, GetPrueflaufControllingAction, PostAufgabeBemerkungSetzenAction, PostAufgabeKorrigierenAction, PostPrueflaufLoeschenAction} from '../../../../client-ngrx/qschecks';
import {PrueflaufAufgabeAntwortRequest, PrueflaufAufgabeBemerkungRequest, VeranstaltungMinimal, VeranstaltungUebersichtRequest} from '../../../../clients/qschecks';
import {getAktuellenPrueflauf, getAktuellePruefaufgabe, getPrueflaufDetail} from './qs-checks-controlling-veranstaltung.selectors';


@Injectable()
export class QsChecksControllingVeranstaltungPageUiEffects {

    @Effect()
    datenLaden$: Observable<Action> = this.actions$.pipe(
        ofType(PAGE_STATE_RESET, VERANSTALTUNG_UEBERSICHT_NEU_LADEN),
        withLatestFrom(this.store$.pipe(select(getAktuelleVeranstaltung)),
            this.store$.pipe(select(getPruefplanId)),
            this.store$.pipe(select(getPrueferRollenIds))),
        filter(([x, aktuelleVeranstaltung, pruefplanId, prueferRollenIds]:
                    [PageStateResetAction, VeranstaltungMinimal, string, Array<string>]) =>
            aktuelleVeranstaltung !== null && pruefplanId !== '' && prueferRollenIds.length > 0),
        map(([x, aktuelleVeranstaltung, pruefplanId, preuferRollenIds]) => {
            const request: VeranstaltungUebersichtRequest = {
                veranstaltung_id: aktuelleVeranstaltung.veranstaltung_id,
                pruefer_rolle_ids: preuferRollenIds,
                pruefplan_id: pruefplanId,
            };
            return new GetVeranstaltungUebersichtAction(request);
        })
    );

    @Effect()
    prueflaufLaden$: Observable<Action> = this.actions$.pipe(
        ofType<AktuellenPrueflaufSetzenAction>(AKTUELLEN_PRUEFLAUF_SETZEN),
        filter((x) => x.payload !== null),
        map((x) => {
            return new GetPrueflaufControllingAction(x.payload.prueflauf_id);
        })
    );

   @Effect()
    prueflaufEntfernen$: Observable<Action> = this.actions$.pipe(
        ofType<AktuellenPrueflaufEntfernenAction>(AKTUELLEN_PRUEFLAUF_ENTFERNEN),
        withLatestFrom(this.store$.pipe(select(getAktuellenPrueflauf))),
        filter(([x, prueflauf]) => prueflauf !== null),
        map(([x, prueflauf]) => {
            return new PostPrueflaufLoeschenAction({
                prueflauf_id: prueflauf.prueflauf_id,
                veranstaltung_id: prueflauf.veranstaltung_id,
                pruefplan_id: prueflauf.pruefplan_id,
                pruefobjekt_id: prueflauf.pruefobjekt_id,
                rolle_id: prueflauf.rolle_id,
            });
        })
    );

    @Effect()
    prueflaufDetailNeuLaden$: Observable<Action> = this.actions$.pipe(
        ofType<PrueflaufDetailNeuLaden>(PRUEFLAUF_DETAIL_NEU_LADEN),
        withLatestFrom(this.store$.pipe(select(getAktuellenPrueflauf))),
        filter(([x, prueflauf]) => prueflauf !== null),
        map(([x, prueflauf]) => {
            return new GetPrueflaufControllingAction(prueflauf.prueflauf_id);
        })
    );

    @Effect()
    pruefaufgabeKorrigieren$: Observable<Action> = this.actions$.pipe(
        ofType<PruefaufgabeKorrigierenAction>(PRUEFAUFGABE_KORRIGIEREN),
        withLatestFrom(this.store$.pipe(select(getPrueflaufDetail))),
        filter(([x, detail]) => x.aufgabe !== null && x.antwort !== null && detail !== null),
        map(([x, detail]) => {
            const request: PrueflaufAufgabeAntwortRequest = {
                veranstaltung_id: detail.veranstaltung_id,
                prueflauf_id: detail.prueflauf_id,
                pruefplan_id: detail.pruefplan_id,
                pruefobjekt_id: detail.pruefobjekt_id,
                rolle_id: detail.rolle_id,
                pruefaufgabe_id: x.aufgabe.pruefaufgabe_id,
                antwort_id: x.antwort.antwort_id,
            };
            return new PostAufgabeKorrigierenAction(request);
        })
    );

    @Effect()
    aufgabeBemerkungSpeichern$: Observable<Action> = this.actions$.pipe(
        ofType<AufgabeBemerkungSpeichernAction>(AUFGABE_BEMERKUNG_SPEICHERN),
        withLatestFrom(this.store$.pipe(select(getPrueflaufDetail)),
            this.store$.pipe(select(getAktuellePruefaufgabe))),
        filter(([x, detail, aufgabe]) => x.payload !== null && detail !== null && aufgabe !== null),
        map(([x, detail, aufgabe]) => {
            const request: PrueflaufAufgabeBemerkungRequest = {
                veranstaltung_id: detail.veranstaltung_id,
                prueflauf_id: detail.prueflauf_id,
                pruefplan_id: detail.pruefplan_id,
                pruefobjekt_id: detail.pruefobjekt_id,
                rolle_id: detail.rolle_id,
                pruefaufgabe_id: aufgabe.pruefaufgabe_id,
                bild_ids: aufgabe.bild_ids,
                bemerkung: x.payload,
            };
            return new PostAufgabeBemerkungSetzenAction(request);
        })
    );


    constructor(private actions$: Actions,
                private uuid: UuidService,
                private store$: Store<any>) {
    }
}
